var App = App || {};

App.Resources = (function ($) {
    "use strict";

    function init() {
        var $resources = $("section.resources"),
            $resourcesItem = $resources.find("a.nav-link");

        $resourcesItem.on("mouseover", function () {
            var $this = $(this),
                $icon = $this.find(".icon");

            $icon.addClass("animate__animated animate__faster animate__pulse");
        });

        $resourcesItem.on("mouseout", function () {
            var $this = $(this),
                $icon = $this.find(".icon");

            $icon.removeClass("animate__animated animate__faster animate__pulse");
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Resources.init();
});